import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { isLanguagesPair } from '@fiverr-private/dynamic_matching';
import { I18n } from '@fiverr-private/i18n-react';
import { Heading, Text } from '@fiverr-private/typography';
import { translateMetadataQuestion, translateMetadataAnswer } from '@fiverr-private/dynamic_matching_copies';
import type { SellerBriefResponse } from '../../../types/SellerBriefResponse';

interface ServiceOptionsProps {
  metadataAnswers?: SellerBriefResponse['metadataAnswers'];
  subCategoryId?: SellerBriefResponse['subCategoryId'];
  nestedSubCategoryId?: SellerBriefResponse['nestedSubCategoryId'];
}

const renderLanguagesPair = ({ languagesPair, metadataType, leafCategoryId }) => {
  const [fromAnswerKey, toAnswerKey] = languagesPair[0].split('-');

  const fromLabel = translateMetadataAnswer({
    leafCategoryId,
    answerSlug: fromAnswerKey,
    metadataType,
  });

  const toLabel = translateMetadataAnswer({
    leafCategoryId,
    answerSlug: toAnswerKey,
    metadataType,
  });

  return (
    <Text>
      <I18n
        k={'brief_preview_drawer.person_brief.translate_from_to'}
        params={{
          from: fromLabel,
          to: toLabel,
        }}
      />
    </Text>
  );
};

export const ServiceOptions: React.FC<ServiceOptionsProps> = ({
  metadataAnswers,
  subCategoryId,
  nestedSubCategoryId,
}) => {
  if (!metadataAnswers?.serviceOptions?.length || !subCategoryId) {
    return null;
  }

  const leafCategoryId = nestedSubCategoryId || subCategoryId;

  return (
    <Stack direction="column" gap="8">
      {metadataAnswers?.serviceOptions.map(({ key: metadataType, values }) => (
        <Stack key={metadataType} direction="column" gap="1">
          <Heading size="h_xxs">
            {
              translateMetadataQuestion({
                metadataType,
                subCategoryId,
                nestedSubcategoryId: nestedSubCategoryId || null,
              }).displayName
            }
          </Heading>
          <Text>
            {isLanguagesPair(metadataType)
              ? renderLanguagesPair({
                  languagesPair: values,
                  metadataType,
                  leafCategoryId,
                })
              : values?.map((value, index) => (
                  <React.Fragment key={value}>
                    {translateMetadataAnswer({
                      leafCategoryId,
                      answerSlug: value,
                      metadataType,
                    })}

                    {index < values.length - 1 && ', '}
                  </React.Fragment>
                ))}
          </Text>
        </Stack>
      ))}
    </Stack>
  );
};
